<template>
    <div class="animated fadeIn">

        <Request
                ref="requestProducts"
                :onRequestSuccess="onRequestSuccess"
                root="/shop/products">
            <slot slot="body">
                <b-card>

                    <b-row class="mb-4 mt-2">
                        <b-col class="text-right">
                            <b-button-group>
                                <b-button @click="onCartClick" class="btn btn-light"> <b-badge class="animated fadeIn badge-success ml-1" v-if="cartCount !== false">{{cartCount}}</b-badge><i class="fa fa-shopping-cart mr-1 ml-2"></i> {{Core.Definition.getDefinition('Mon panier')}}</b-button>
                                <b-button @click="switchDisplay('list')" :class="{ 'btn-light' : dataDisplay === 'grid', 'btn-primary' : dataDisplay === 'list'}" class="btn"><i class="fa fa-list mr-1"></i></b-button>
                                <b-button @click="switchDisplay('grid')" :class="{ 'btn-light' : dataDisplay === 'list', 'btn-primary' : dataDisplay === 'grid'}" class="btn"><i class="fa fa-table mr-1"></i></b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col lg="3">
                            <InputSelect
                                    :search="false"
                                    v-if="displayFilterBranch&&dataSelectOptions.branchId.length>0"
                                    v-model="dataFilter.branchId"
                                    :options="dataSelectOptions.branchId"
                                    :label="Core.Definition.getDefinition('Établissement')">
                            </InputSelect>

                            <InputSelect
                                    :search="false"
                                    v-if="displayFilterProductCategory&&dataSelectOptions.productCategoryId.length>0"
                                    v-model="dataFilter.productCategoryId"
                                    :options="dataSelectOptions.productCategoryId"
                                    :label="Core.Definition.getDefinition('Catégorie de produit')">
                            </InputSelect>

                            <InputSelect
                                    :search="false"
                                    v-if="displayFilterProductType"
                                    v-model="dataFilter.productType"
                                    :options="dataSelectOptions.type"
                                    :label="Core.Definition.getDefinition('Type')">
                            </InputSelect>

                            <InputText
                                    v-if="displayFilterProductTitle"
                                    v-model="dataFilter.productTitle"
                                    :label="Core.Definition.getDefinition('Titre')">
                            </InputText>

                            <b-button-group class="btn-group-sm mt-4">
                                <b-button @click="onResetClick" class="btn btn-light mr-2">{{Core.Definition.getDefinition('Réinitialiser')}}</b-button>
                                <b-button @click="onSearchClick" class="btn btn-info">{{Core.Definition.getDefinition('Rechercher')}}</b-button>
                            </b-button-group>
                        </b-col>
                        <b-col lg="9">
                            <div v-if="dataDisplay === 'grid'">
                                <b-row class="mt-2">
                                    <b-col :key="productIndex" v-for="product, productIndex in dataProducts" lg="4">
                                        <ProductGrid :key="'pGrid' + productIndex"  class="animated fadeIn" v-model="dataProducts[productIndex]" @onCartClick="onCartClick" @onAddToCartClick="onAddToCartClick" @onPreviewClick="onPreviewClick"></ProductGrid>
                                    </b-col>
                                </b-row>
                            </div>
                            <div v-if="dataDisplay === 'list'">
                                <ProductRow @onCartClick="onCartClick" @onAddToCartClick="onAddToCartClick" @onPreviewClick="onPreviewClick" class="animated fadeIn"  :key="'pRow' + productIndex" v-for="product, productIndex in dataProducts" v-model="dataProducts[productIndex]"></ProductRow>
                            </div>
                            <b-row class="text-center mt-4">
                                <b-col>
                                    <b-button @click="onViewMoreClick" class="btn btn-light">{{Core.Definition.getDefinition('Voir plus')}} <i class="fa fa-chevron-down"></i></b-button>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>

                </b-card>
            </slot>
        </Request>

    </div>
</template>

<script>
    import ProductGrid from '../../../components/ProductGrid'
    import ProductRow from '../../../components/ProductRow'
    import Request from '../../../components/Request'
    import InputText from '../../../components/InputText'
    import InputSelect from '../../../components/InputSelect'
    export default {
        name: 'Products',
        components: {
            ProductGrid,
            Request,
            ProductRow,
            InputText,
            InputSelect
        },
        props: {
            cartRedirectType: {
                type: String,
                default: 'router'
            },
            cartRedirectUrl: {
                type: String,
                default: ''
            },
            productPreviewRedirectType: {
                type: String,
                default: ''
            },
            productPreviewRedirectUrl: {
                type: String,
                default: ''
            },
            displayMode: {
                type: String,
                default: 'grid'
            },
            displayFilters: {
                type: Boolean,
                default: true
            },
            displayFilterProductTitle: {
                type: Boolean,
                default: true
            },
            displayFilterBranch: {
                type: Boolean,
                default: false
            },
            displayFilterProductCategory: {
                type: Boolean,
                default: true
            },
            displayFilterProductType: {
                type: Boolean,
                default: false
            },
            productCategoryId: {
                type: String | Number,
                default: ''
            },
            productId: {
                type: String | Number,
                default: ''
            },
            productType: {
                type: String | Number,
                default: ''
            },
            branchId: {
                type: String | Number,
                default: ''
            }
        },
        mounted() {
            Core.Session.Cart.retrieve()
            this.dataDisplay = this.displayMode

            let productId = this.productId
            if(this.$route !== undefined && this.$route.query !== undefined && this.$route.query.productId !== undefined) {
                productId = this.$route.query.productId
            }

            let url = new URL(window.location.href);
            let urlProductId = url.searchParams.get('productId');
            if (urlProductId !== undefined && urlProductId !== '') {
                productId = urlProductId
            }

            this.requestProducts(this.productCategoryId, this.productType, this.branchId, productId)
        },
        data: function () {
            return {
                Core: window.Core,
                dataProducts: [],
                dataSize: 10,
                dataFilter: {
                    productCategoryId: '',
                    productType: '',
                    branchId: '',
                    productTitle: ''
                },
                dataSelectOptions: {
                    type: [],
                    productCategoryId: [],
                    branchId: []
                },
                dataDisplay: 'grid'
            }
        },
        computed: {
            cartCount() {
                let count = 0
                let products = Core.Session.Cart.products
                for(let product in products) {
                    product = products[product]
                    if ( product.quantity !== undefined) {
                        count += parseInt(product.quantity)
                    }
                }
                return count
            },
        },
        methods: {
            switchDisplay(display) {
                this.dataDisplay = display
            },
            onRequestSuccess(data) {
                this.dataProducts = []
                if (data.products !== undefined) {
                    this.dataProducts = data.products
                }
                if (data.selectOptions !== undefined) {

                    if (data.selectOptions.productCategoryId !== undefined) {
                        this.dataSelectOptions.productCategoryId = data.selectOptions.productCategoryId
                    }
                    if (data.selectOptions.type !== undefined) {
                        this.dataSelectOptions.type = data.selectOptions.type
                    }
                    if (data.selectOptions.branchId !== undefined) {
                        this.dataSelectOptions.branchId = data.selectOptions.branchId
                    }

                    if (Core.Validation.isId(this.productCategoryId)) {
                        this.dataFilter.productCategoryId = Core.Value.selectValue(this.productCategoryId,  this.dataSelectOptions.productCategoryId)
                    }
                    if (Core.Validation.isId(this.branchId)) {
                        this.dataFilter.branchId = Core.Value.selectValue(this.branchId,  this.dataSelectOptions.branchId)
                    }
                    if (Core.Validation.isId(this.productType)) {
                        this.dataFilter.productType = Core.Value.selectValue(this.productType,  this.dataSelectOptions.type)
                    }
                }
            },
            requestProducts(productCategoryId, productType, branchId, productId) {

                if (productCategoryId === undefined) {
                    productCategoryId = Core.Value.decode(this.dataFilter.productCategoryId, Core.Value.typeSelect)
                }

                if (productType === undefined) {
                    productType = Core.Value.decode(this.dataFilter.productType, Core.Value.typeSelect)
                }

                if (branchId === undefined) {
                    branchId = Core.Value.decode(this.dataFilter.branchId, Core.Value.typeSelect)
                }

                this.$refs.requestProducts.clearArgs()
                this.$refs.requestProducts.addArg('size', this.dataSize)
                this.$refs.requestProducts.addArg('type', productType)
                this.$refs.requestProducts.addArg('productCategoryId', productCategoryId)
                this.$refs.requestProducts.addArg('productId', productId)
                this.$refs.requestProducts.addArg('title', this.dataFilter.productTitle)
                this.$refs.requestProducts.addArg('branchId', branchId)
                this.$refs.requestProducts.request()
            },
            onSearchClick() {
                this.requestProducts()
            },
            onResetClick() {
                this.dataFilter.type = null
                this.dataFilter.productCategoryId = null
                this.dataFilter.title = ''
                this.dataFilter.branchId = null
                this.requestProducts()
            },
            onViewMoreClick() {
              this.dataSize += 10
                this.requestProducts()
            },
            onAddToCartClick(product) {
                Core.Session.Cart.add2(product)
            },
            onCartClick(selectedProduct, product) {

                if (product !== undefined && !Core.Session.Cart.hasProduct(product.id)) {
                    product.quantity = 1
                    this.onAddToCartClick(product)
                }

                let cartRedirectUrl = ''
                if (this.cartRedirectUrl !== '') {
                    cartRedirectUrl = this.cartRedirectUrl
                }

                switch(this.cartRedirectType) {
                    case 'router':
                        if (cartRedirectUrl==='') {
                            cartRedirectUrl = Core.Definition.getDefinition('/commerce/boutique/panier')
                        }
                        this.$router.push(cartRedirectUrl)
                        break
                    case 'url':
                        if (cartRedirectUrl!=='') {
                            window.open(cartRedirectUrl, '_self');
                        }
                        break
                }
            },
            onPreviewClick(product) {
                let productPreviewRedirectUrl = ''
                if (this.productPreviewRedirectUrl !== '') {
                    productPreviewRedirectUrl = this.productPreviewRedirectUrl
                }
                switch(this.productPreviewRedirectType) {
                    case 'router':
                        if (productPreviewRedirectUrl==='') {
                            productPreviewRedirectUrl = Core.Text.format(Core.Definition.getDefinition('/commerce/boutique/produit/{0}'), product.id)
                        }
                        this.$router.push(productPreviewRedirectUrl)
                        break
                    case 'url':
                        if (productPreviewRedirectUrl!=='') {
                            window.location.href = productPreviewRedirectUrl
                        }
                        break
                }
            }
        }
    }
</script>
